module.exports = __webpack_public_path__ + "static/python-3-d943c0e50cc98506ce817675a2eb0546.svg";